type NonFacetParamConfig = {
    [key: string]: string;
    paramKey: string;
    searchEngineParamKey: string;
};

type NonFacetSearchParams = NonFacetParamConfig[];

export const nonFacetSearchParams: NonFacetSearchParams = [
    {
        paramKey: "query",
        searchEngineParamKey: "query",
    },
    {
        paramKey: "sort",
        searchEngineParamKey: "sort",
    },
    {
        paramKey: "startRank",
        searchEngineParamKey: "start_rank",
    },
];
